export const getAuthorsCitation = (
  authorNames: (string | undefined)[],
): string => {
  const nonBlankAuthorNames = authorNames.filter((name) => name && name.trim());

  return nonBlankAuthorNames.join("; ");
};
